import axios from '@/api/api.js'
import store from '../store/index.js'
import $public from './public.js'
let shopInfo = store.state.shopInfo;
console.log(shopInfo)
export default {
	printTicketSaleOrder(data) {
		let obj = data.pos58;
		return new Promise((resolve, reject) => {
			let params = {
				"ReportName": "hsorder",
				"Params": [{
					"Variables": [
						{
							"name": "shopName",
							"datatype": "string",
							"value": obj.shopName,
						},
						{
							"name": "orderNumber",
							"datatype": "string",
							"value":obj.orderNumber,
						},
						{
							"name": "createTime",
							"datatype": "string",
							"value": obj.createTime,
						},
						{
							"name": "count",
							"datatype": "string",
							"value":  obj.count.toFixed(2)+'',
						},
						{
							"name": "totalMoney",
							"datatype": "string",
							"value": obj.totalMoney.toFixed(2)+'',
						},
						{
							"name": "discountMoney",
							"datatype": "string",
							"value":obj.discountMoney.toFixed(2)+'',
						},
						{
							"name": "yingfu",
							"datatype": "string",
							"value": $public.jia(obj.totalMoney,obj.discountMoney).toFixed(2)+'',
						},
						{
							"name": "accountMoney",
							"datatype": "string",
							"value":  obj.accountMoney+'',
						},
						{
							"name": "address", // 订单总金额
							"datatype": "string",
							"value":obj.address,
						},
						{
							"name": "linkPhone",  // 折扣优惠
							"datatype": "string",
							"value": obj.linkPhone
						},
					],
					"DataObjects": [
						{
							"name": "goodsItems",
							"value": JSON.stringify(obj.goodsItems),
						},
						{
							"name": "payInfos",
							"value": JSON.stringify(obj.payInfos),
						},
					]
				}],
				
			}
			axios.post('http://print.hscw8.com/print/do', params).then(response => {
				resolve(response);
			}).catch(err => {
				reject(err)
			})
		})
	},
	printTicketRechargeOrder(obj) {
		return new Promise((resolve, reject) => {
			let payWay = ''
			if(!$public.isNull(obj.payInfo)&&!$public.isNull(obj.payInfo.payList)){
				let payList = obj.payInfo.payList
				for(let i=0;i<payList.length;i++){
					if(payList[i].payType==0){
						payWay += ' 现金￥'+payList[i].money
					}else if(payList[i].payType==1){
						payWay += ' 支付宝￥'+payList[i].money
					}if(payList[i].payType==2){
						payWay += ' 微信￥'+payList[i].money
					}else if(payList[i].payType==4){
						payWay += ' 余额￥'+payList[i].money
					}else if(payList[i].payType==3){
						payWay += ' pos机￥'+payList[i].money
					}else if(payList[i].payType==8){
						payWay += ' 第三方￥'+payList[i].money
					}
				}
			}
			let params = {
				"ReportName": "recharge",
				"Params": [{
					"Variables": [
						{
							"name": "shopName",
							"datatype": "string",
							"value": shopInfo.name,
						},
						{
							"name": "shopTel",
							"datatype": "string",
							"value":shopInfo.tel,
						},
						{
							"name": "shopWorkTime",
							"datatype": "string",
							"value":shopInfo.businessHours,
						},
						{
							"name": "shopAddress",
							"datatype": "string",
							"value":shopInfo.address,
						},
						{
							"name": "shopLogo",
							"datatype": "image",
							"value": shopInfo.logo,
						},
						{
							"name": "shopQR",
							"datatype": "image",
							"value":  shopInfo.qrCode,
						},
						{
							"name": "orderNo",
							"datatype": "string",
							"value": obj.orderNo,
						},
						{
							"name": "orderTime",
							"datatype": "string",
							"value":$public.FTime(obj.operationInfo.create.handleTimeStamp),
						},
						{
							"name": "customerPhone",
							"datatype": "string",
							"value": obj.userInfo.userMobile,
						},
						{
							"name": "remark",
							"datatype": "string",
							"value":  obj.remark,
						},
						{
							"name": "rechargeAmount", // 充值金额
							"datatype": "string",
							"value": $public.jia(obj.totalPrice,obj.giveMoney),
						},
						{
							"name": "useableAmount",  // 可用余额
							"datatype": "string",
							"value": obj.payInfo.surplusMoney,
						},
						{
							"name": "currentGrowValue",  // 当前成长值
							"datatype": "string",
							"value": obj.payInfo.score,
						},
						{
							"name": "payAmount",
							"datatype": "string",
							"value": payWay,
						}
					]
				}],
			}
			console.log(params)
			axios.post('http://127.0.0.1:9390/Print', params).then(response => {
				resolve(response.data);
			}).catch(err => {
				reject(err)
			})
		})
	},
	printTicketBarCode(obj) {
		return new Promise((resolve, reject) => {
			let value = []
			console.log(obj,'obj[i]');
			for(let i=0;i<obj.length;i++){
				value.push(
					{
						title:obj[i].name+' '+obj[i].sku+' '+obj[i].unit,
						code:obj[i].code+'',
						price:obj[i].price>0?  "价格：￥"+obj[i].price:'',
					}
				)
			}
			let params = {
				"ReportName":"hscwbarcode",
				"Params":[
					{
						"DataObjects":[
							{
								"name": "data",
								"value":JSON.stringify(value),
							}
						]
					}
				],
			}
			axios.post('http://print.hscw8.com/print/do', params).then(response => {
				resolve(response);
			}).catch(err => {
				reject(err)
			})
		})
	},
	// 打印含有会员价的条码
	printTicketBarCodeN(obj) {
		return new Promise((resolve, reject) => {
			let value = []
			for(let i=0;i<obj.length;i++){
				value.push(
					{
						title:obj[i].name+' '+obj[i].sku+' '+obj[i].unit,
						code:obj[i].code+'',
						price:obj[i].price>0&&obj[i].mprice>0?  "标准价：￥"+obj[i].price+' '+"会员价：￥"+obj[i].mprice:'',
					}
				)
			}
			let params = {
				"ReportName":"hscwbarcode",
				"Params":[
					{
						"DataObjects":[
							{
								"name": "data",
								"value":JSON.stringify(value),
							}
						]
					}
				],
			}
			axios.post('http://print.hscw8.com/print/do', params).then(response => {
				resolve(response);
			}).catch(err => {
				reject(err)
			})
		})
	},
	// 打印折扣码
	printTicketBarCodes(obj) {
		return new Promise((resolve, reject) => { 
			let params = {
				"ReportName":"goodsdiscountcode",
				"Params":[
					{
						"Variables":[
							{
								"name": "code",
								"datatype": "string",
								"value": obj.code,
							},
							{
								"name": "title",
								"datatype": "string",
								"value": obj.name,
							},
						]
					}
				],
			}
			axios.post('http://print.hscw8.com/print/do', params).then(response => {
				resolve(response);
			}).catch(err => {
				reject(err)
			})
		})
	},
	
}